// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/soc-frontend/" + chunkId + "." + {"4":"88a15464","81":"64f7a842","223":"81ea782b","325":"d2bb015b","495":"9538213d","682":"e68029ab","967":"c52f4f24"}[chunkId] + ".chunk.js";
};